import type { ConfigItem } from '@/types/devices'
import { getConfigByKey } from './device-config'

export enum ZeroState {
  USER_ZERO_APPLIED = 'user_zero_applied',
  USER_ZERO_REQUESTED = 'user_zero_requested',
  FACTORY_ZERO_APPLIED = 'factory_zero_applied',
  FACTORY_ZERO_REQUESTED = 'factory_zero_requested'
}

export const ZEROING_SENSORS = ['co', 'no2', 'so2', 'o3'] as const

export interface UserZero {
  zero_state: ZeroState | null
  userzero: boolean | null
  zero_requested_at: string | null
  zero_applied_at: string | null
}

export const getUserZeros = (
  zeroableSensors: string[],
  cloudConfig: ConfigItem[],
  zeroAppliedAtMap: Record<string, string> | null,
  zeroStateMap: Record<string, string> | null
): Record<string, UserZero> => {
  const userZeros: Record<string, UserZero> = {}

  for (const sensorName of zeroableSensors) {
    const zeroStateFromConfig = getConfigByKey(
      cloudConfig,
      sensorName.concat('_zero_state')
    ) as string
    const zeroRequestedAt = getConfigByKey(
      cloudConfig,
      sensorName.concat('_zero_requested_at')
    ) as string
    let zeroAppliedAt: string | undefined
    let zeroStateFromState: string | undefined

    if (zeroAppliedAtMap) {
      zeroAppliedAt = zeroAppliedAtMap[sensorName.concat('_zero_applied_at')]
    }
    if (zeroStateMap) {
      zeroStateFromState = zeroStateMap[sensorName.concat('_zero_state')]
    }

    if (zeroStateFromConfig && zeroRequestedAt) {
      if (zeroAppliedAt && Date.parse(zeroRequestedAt) <= Date.parse(zeroAppliedAt)) {
        userZeros[sensorName] = {
          zero_state: (zeroStateFromState ?? null) as ZeroState,
          userzero: null,
          zero_requested_at: zeroRequestedAt,
          zero_applied_at: zeroAppliedAt
        }
      } else {
        userZeros[sensorName] = {
          zero_state: (zeroStateFromConfig ?? null) as ZeroState,
          userzero: null,
          zero_requested_at: zeroRequestedAt,
          zero_applied_at: null
        }
      }
    } else {
      userZeros[sensorName] = {
        zero_state: ZeroState.FACTORY_ZERO_APPLIED,
        userzero: null,
        zero_requested_at: null,
        zero_applied_at: null
      }
    }
  }
  return userZeros
}
